/**
 * 所有可能的停靠位置
 */
export type IPublicTypeWidgetConfigArea = 'leftArea' | 'left' | 'rightArea' |
  'right' | 'topArea' | 'subTopArea' | 'top' |
  'toolbar' | 'mainArea' | 'main' |
  'center' | 'centerArea' | 'bottomArea' |
  'bottom' | 'leftFixedArea' |
  'leftFloatArea' | 'stages';
